// extracted by mini-css-extract-plugin
export default {"table":"ccf-contact-history-table_table__uOAuU","tableBody":"ccf-contact-history-table_tableBody__-05-G"};